import React from 'react'
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'


function LiveTransactions() {
  return (
    <IncludeSideBar>
        <div>
            <p>
                Here we are displaying the Transaction Happened in Live
            </p>
        </div>
    </IncludeSideBar>
  )
}

export default LiveTransactions